import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
    AdaptedSelect,
    DropzoneControl,
    Optional,
    TextareaControl
} from "../components/Form";
import { AdvertisementPosition } from "../graphql";

export interface IAdvertisementFormValues {
  position: AdvertisementPosition;
  isActive: "0" | "1";
  clickUrl: string;
  media: {
    key: string;
  };
}

export const AdvertisementPositionLabel = {
    ARTICLES_HOME_TOP: "Në krye të listës së artikujve",
    ARTICLES_HOME_BOTTOM: "Në fund të listës së artikujve",
    ARTICLE_BOTTOM: "Në fund të artikullit"
};

interface IAdvertisementForm {
  onSubmit: (values: IAdvertisementFormValues) => void;
  initialValues?: Optional<IAdvertisementFormValues>;
}

export const AdvertisementForm: React.FC<IAdvertisementForm> = React.memo(
    ({ onSubmit, initialValues }) => {
        const validate = (values) => {
            const errors: { [key: string]: string } = {};

            const isActive = values.isActive === "1";

            if (!values.position) {
                errors.position = "Fushë e detyruar";
            }

            if (!values.isActive) {
                errors.isActive = "Fushë e detyruar";
            }

            if (isActive && !values?.media?.key) {
                errors.media = "Fushë e detyruar";
            }

            return errors;
        };

        return (
            <Form
                onSubmit={ onSubmit }
                validate={ validate }
                initialValues={ initialValues }
                render={ ({
                    handleSubmit,
                    form,
                    errors,
                    submitting,
                    pristine,
                    values
                }) => (
                    <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                        <Field name="position" component={ AdaptedSelect } label="Pozicioni">
                            <option value={ "ARTICLES_HOME_TOP" }>
                                { AdvertisementPositionLabel["ARTICLES_HOME_TOP"] }
                            </option>
                            <option value={ "ARTICLES_HOME_BOTTOM" }>
                                { AdvertisementPositionLabel["ARTICLES_HOME_BOTTOM"] }
                            </option>
                            <option value={ "ARTICLE_BOTTOM" }>
                                { AdvertisementPositionLabel["ARTICLE_BOTTOM"] }
                            </option>
                        </Field>

                        <Field name="isActive" component={ AdaptedSelect } label="Aktive?">
                            <option value="1">Po</option>
                            <option value="0">Jo</option>
                        </Field>

                        <DropzoneControl name="media" label="Figura" />

                        <TextareaControl name="clickUrl" label="URL ku drejton figura" />

                        <ButtonGroup spacing={ 4 }>
                            <Button
                                isLoading={ submitting }
                                loadingText="Duke dërguar"
                                variantColor="teal"
                                type="submit"
                            >
                                Ruaj
                            </Button>
                            <Button
                                variantColor="teal"
                                variant="outline"
                                onClick={ form.reset }
                                isDisabled={ submitting || pristine }
                            >
                                Pastro
                            </Button>
                        </ButtonGroup>
                    </Box>
                ) }
            />
        );
    }
);
